/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ConfirmationModal } from '../../common/Modals/ConfirmationModal/ConfirmationModal';
import { notaryAPI } from '../../../api/notary';
import { State } from '../../../redux';
import { getConfig } from '@utils/configs';
import { get } from '@utils/lodash';

export interface ParticipantRoomWrapperProps {
  children?: React.ReactNode;
}

// This wrapper is specifically for a NOTARY user as it checks whether the user has the proper
// notary credentials uploaded. It should only be used to wrap components that must only be accessed
// by notaries.
export const ProfileCheckWrapper: React.SFC<ParticipantRoomWrapperProps> = ({ children }) => {
  const history = useHistory();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const user = useSelector((state: State) => state.user);

  const ensureAuthorized = useCallback(async () => {
    const { isProfileComplete } = await notaryAPI.users.checkProfileStatus(user.id);
    setIsAuthorized(isProfileComplete);
  }, [get(history, 'location.pathname')]);

  useEffect(() => {
    ensureAuthorized();
  }, []);

  if (isAuthorized === null) {
    return null;
  }

  if (!isAuthorized) {
    return (
      <ConfirmationModal
        heading={'Not Authorized'}
        contentLabel={'not authorized'}
        isOpen={!isAuthorized}
        description={'Please complete your notary profile'}
        confirmButtonText={'Update Profile'}
        handleConfirm={() => {
          window.location.href = `${getConfig().blendBridge.url}/profile`;
        }}
      ></ConfirmationModal>
    );
  }

  return <>{children}</>;
};
